import axios from 'axios';
import { GIFT_TABLE_ROOT as ROOT, BASE_PATH_API } from 'constants/env';

async function getEventTypes() {
  const res = await axios({
    url: `${BASE_PATH_API}/${ROOT}/event`,
  });
  // console.log('DataEventes:',res.data.data);
  return res.data.data;
}
async function getPlans() {
  const res = await axios({
    url: `${BASE_PATH_API}/${ROOT}/plan`,
  });
  return res.data.data;
}
async function getGuestRange() {
  const res = await axios({
    url: `${BASE_PATH_API}/${ROOT}/guest-range`,
  });
  return res.data.data;
}
async function getEventImages(eventType) {
  const res = await axios({
    url: `${BASE_PATH_API}/${ROOT}/image-gallery/${eventType}`,
  });
  return res.data.data;
}

export { getEventTypes, getPlans, getGuestRange, getEventImages };
